import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { CallToAction } from 'components/CallToAction'
import { prepareData } from 'utils/googleData'

const FeatureSnapshotTitle = ({ subtitle, title, cta, description }) => {
    return (
        <div className="col-span-3 text-center lg:text-left">
            {title && <h2 className="leading- center mb-2 text-4xl leading-tight lg:mb-4 lg:text-5xl">{title}</h2>}
            {subtitle && <h3 className="center mb-4 text-lg lg:text-2xl">{subtitle}</h3>}
            {description && <p className="center mb-4 text-lg lg:text-2xl">{description}</p>}
            {cta?.url && (
                <CallToAction to={cta?.url} type="secondary" className="!w-full lg:!w-auto lg:min-w-[200px]">
                    {cta?.label}
                </CallToAction>
            )}
        </div>
    )
}
export function FeatureSnapshot(props) {
    const {
        enable,
        title,
        name,
        subtitle,
        description,
        cta,
        direction,
        style = '',
        gatsbyImage,
        gatsbyImage2,
        gatsbyImage3,
        text,
        gatsbyImageSrc,
        size = 'lg',
        features,
        reverse,
    } = prepareData({ props })

    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <div>
            <FeatureSnapshotTitle title={title} subtitle={subtitle} description={description} />
            <div
                className={`flex flex-col items-center space-x-0 space-y-4 lg:space-x-9 lg:space-y-0 ${
                    reverse ? 'lg:flex-row-reverse lg:space-x-reverse' : 'lg:flex-row'
                }`}
            >
                <div className="relative col-span-2 w-full overflow-hidden rounded-[10px] bg-gray-accent-light lg:min-h-[400px] lg:w-2/3">
                    {gatsbyImage && <GatsbyImage alt={''} image={gatsbyImage} placeholder="blurred" />}
                    {gatsbyImageSrc && (
                        <img className="inset-0 h-full w-full object-contain lg:absolute" alt="" src={gatsbyImageSrc} />
                    )}
                </div>
                <div className="w-full lg:w-1/3">
                    <ul className="m-0 list-none p-0">
                        {features?.length > 0 &&
                            features.map((feature, index) => {
                                return (
                                    <li
                                        className="border-b border-dashed border-gray-accent-light py-4 last:border-b-0"
                                        key={index}
                                    >
                                        {feature?.name}
                                    </li>
                                )
                            })}
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default FeatureSnapshot
